import { createFileRoute } from '@tanstack/react-router'
import { TemplatesList } from '@/features/templates/list'

export const Route = createFileRoute('/templates/')({
  component: TemplatesList,
})
